import { CriticalSection } from "utils/sync";

export const crs_fieldBlur_ActionClick = new CriticalSection();